import React from "react";
import PropTypes from "prop-types";
import SimpleVirtualizedAutocomplete from "../../Dropdown/SimpleVirtualizedAutocomplete";
import { Tooltip } from "@mui/material";

const AddContactRow = ({ row, handlers }) => {
  const { roleKey, roleLabel } = row;
  const { contactOptions, addContactForRole } = handlers;

  const handleOnChange = (event, newValue) => {
    addContactForRole(roleKey, newValue ? newValue.contactID : "");
  };

  return (
    <tr className="border-t hover:bg-cyan-50 hover:shadow-md">
      <td className="px-2 py-1 border border-white text-center bg-white" />
      <Tooltip title={roleLabel} enterDelay={1000}>
        <td className="border font-medium text-nowrap px-2 py-1">
          {roleLabel}
        </td>
      </Tooltip>
      <td className="border" colSpan={4}>
        <SimpleVirtualizedAutocomplete
          options={handlers.contactOptions}
          value={null}
          onChange={handleOnChange}
          optionKey="contactID"
          optionLabel="contactName"
          placeholder="Select a contact..."
          itemSize={40}
          maxVisibleItems={8}
          className="w-full py-1 px-2"
        />
      </td>
    </tr>
  );
};

AddContactRow.propTypes = {
  row: PropTypes.shape({
    roleKey: PropTypes.string.isRequired,
    roleLabel: PropTypes.string.isRequired,
  }).isRequired,
  handlers: PropTypes.shape({
    contactOptions: PropTypes.array.isRequired,
    addContactForRole: PropTypes.func.isRequired,
  }).isRequired,
};

export default AddContactRow;
